const decimalPlacesValue = 2;
/**
 * Takes a currency number and returns the standard formatted
 * currency string in dollars and cents
 *
 * @param num Number to convert to currency
 * @returns Formatted string currency (or 'N/A' if null input)
 */
export function convertNumberToCurrency(num: number | null): string {
  if (typeof num !== 'number') {
    return 'N/A';
  }
  const value = Math.abs(num)
    .toFixed(decimalPlacesValue)
    .replace(/\d(?=(\d{3})+\.)/g, '$&,');
  return num < 0 ? `($${value})` : `$${value}`;
}

/**
 * Takes a currency number and returns a formatted string based
 * on the argument passed
 *
 * @param decimalPlaces Number of decimal places to display (default = none)
 * @returns Formatted string currency
 */
export function convertNumberToSimpleCurrency(num: number | null, decimalPlaces = 0): string {
  if (typeof num !== 'number') {
    return 'N/A';
  }
  const formattedValue = Math.abs(num)
    .toFixed(decimalPlaces)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  return num < 0 ? `($${formattedValue})` : `$${formattedValue}`;
}

// Simple number formatter (add proper commas)
export function formatNumber(
  num: number | null | undefined,
  decimalPlaces = decimalPlacesValue,
  includeParentheses = false
): string {
  if (typeof num !== 'number') {
    return 'N/A';
  }
  if (includeParentheses) {
    const values = Math.abs(num).toFixed(decimalPlaces);
    const output = values.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return num < 0 ? `(${output})` : output;
  }
  const value = num.toFixed(decimalPlaces);
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
